module.exports = __webpack_public_path__ + "static/media/trophy-2.d09a8d76.svg";